import { IAutoMapper } from "../interfaces";

export const mapAlertItemQualifiers = (automapper: IAutoMapper): void => {
    automapper
        .createMap("default", "AlertItemQualifier")
        .forMember("id", o => o.id)
        .forMember("name", o => o.name)
        .forMember("type", o => o.type);
};
